import { render } from "./BomCellQuantity.vue?vue&type=template&id=515c2c6a&scoped=true"
import script from "./BomCellQuantity.vue?vue&type=script&lang=js"
export * from "./BomCellQuantity.vue?vue&type=script&lang=js"

import "./BomCellQuantity.vue?vue&type=style&index=0&id=515c2c6a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515c2c6a"]])

export default __exports__